export default function (dom, opts) {
    let options = {
        eventBtnSel: '.addeventatc',
        ...opts
    }


    const eventButton = Array.from(dom.querySelectorAll(options.eventBtnSel));

    function init() {
        eventButton.forEach(e => {
            e.style.setProperty('color', '#fff', 'important');
            e.style.setProperty('box-shadow', 'none', 'important');
        })
    }

    init()

}
